import { createContext } from 'react';
import { I18nContextValue } from '../../types/i18n/i18n.type';

/**
 * Context for managing internationalization (i18n) state and translation utilities.
 *
 * Provides access to the current language, translation function, client type,
 * and language setter throughout the application. Must be used with I18nProvider.
 *
 * @example
 * ```tsx
 * // Use with the useI18n hook:
 * const { t, language, setLanguage } = useI18n();
 * return <div>{t('common.hello')}</div>;
 * ```
 *
 * @see I18nProvider - The provider component that initializes this context
 * @see useI18n - Hook to safely access this context
 */
export const I18nContext = createContext<I18nContextValue | null>(null);
